import ReactDOM from 'react-dom';
import './ModalStyles.scss';
import gsap from 'gsap';
import useGsapContext from '../../hooks/UseGsapContext';
import { useLayoutEffect, useRef } from 'react';
import useScrollBlock from 'src/app/hooks/useScrollBlock';

const scenesImages = require.context('../../../assets/scenes');

const ModalScene = ({ data, setisModalActive }) => {
  const [blockScroll, allowScroll] = useScrollBlock();
  // Media Queries
  const mql = window.matchMedia('(max-width: 978px)');
  const isClosed = useRef(false);

  // STATES & GSAP CONTEXT
  const modal = useRef();
  const ctx = useGsapContext(modal);
  // ANIMATION
  const openModalAnimation = () => {
    isClosed.current = true;
    const start = gsap.timeline({ duration: 0.1 });
    if (!mql.matches) {
      start.to('.modal', {
        keyframes: [
          {
            scale: 0,
            x: -window.innerWidth,
            y: window.innerHeight,
            autoAlpha: 0,
          },
          { scale: 1, x: 0, y: 0, autoAlpha: 1 },
        ],
      });
    } else {
      start.to('.modal', {
        keyframes: [
          {
            scale: 0,
            x: 0,
            y: 0,
            autoAlpha: 0,
          },
          { scale: 1, x: 0, y: 0, autoAlpha: 1 },
        ],
      });
    }

    start.to('.modal-content', {
      keyframes: { y: [100, 0], opacity: [0, 1] },
    });
    start.to(
      '.modal-container-menu',
      {
        keyframes: { y: [100, 0], opacity: [0, 1] },
      },
      '<'
    );
    blockScroll();
  };
  const closeModalAnimation = () => {
    const end = gsap.timeline({ duration: 0.1 });
    if (!mql.matches && isClosed.current) {
      end.to(
        '.modal',
        {
          keyframes: [
            { autoAlpha: 1 },
            {
              autoAlpha: 0,
            },
          ],
        },
        '<'
      );
    } else {
      isClosed.current &&
        end.to(
          '.modal',
          {
            keyframes: [
              { scale: 1, x: 0, y: 0, autoAlpha: 1 },
              {
                scale: 0,
                x: 0,
                y: 0,
                autoAlpha: 0,
              },
            ],
          },
          '<'
        );
    }

    setTimeout(() => {
      if (isClosed.current) {
        setisModalActive(false);
        allowScroll();
        isClosed.current = false;
      }
    }, 1000);
  };

  // GSAP CONTEXT
  useLayoutEffect(() => {
    modal.current.focus();
    ctx.add(() => {
      gsap.set('.modal-content', { opacity: 0 });
      gsap.set('.modal-container-menu', { opacity: 0 });
      gsap.set('.modal', {
        scale: 0,
        x: -window.innerWidth,
        y: window.innerHeight,
        autoAlpha: 0,
      });
      openModalAnimation();
    });
    return () => ctx.revert();
  });

  return ReactDOM.createPortal(
    <section ref={modal} autofoucus>
      <div className="modal" aria-modal="true">
        <div className="modal-container">
          <div className="modal-container-menu">
            <button
              onClick={() => closeModalAnimation()}
              aria-label="Cerrar modal"
            >
              <i className="icons-ciat icon-close"></i>
            </button>
            <ol aria-hidden="true">
              {data.map((item, index) => (
                <li key={`${index}MM`}>
                  <p>{item?.title}</p>
                </li>
              ))}
            </ol>
          </div>
          <button
            className="modal-container-close"
            onClick={() => closeModalAnimation()}
            aria-label="Cerrar modal"
          >
            <i className="icons-ciat icon-close"></i>
          </button>
          <div
            className="modal-content"
            role="dialog"
            aria-labelledby="dialog1_label"
          >
            <div className="modal-content-column">
              {data
                ?.filter((_, index) => index % 2 === 0) // Filtra solo los índices pares
                .map((item, index) => (
                  <div key={`${index}MM`}>
                    {!item.linkTitle && (
                      <h3
                        className={`modal-content-box-title ${
                          item.title.lenght > 37 ? 'w-100' : ''
                        }`}
                      >
                        {item.title}
                      </h3>
                    )}
                    {item.linkTitle && (
                      <a
                        href={item?.linkTitle}
                        className="link"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <h3
                          className={`modal-content-box-title  ${
                            item.title.lenght > 37 ? 'w-100' : ''
                          }`}
                        >
                          {' '}
                          {item.title}
                        </h3>
                      </a>
                    )}
                    <img
                      className="modal-content-box-image"
                      src={scenesImages(`${item?.img?.url}`)}
                      width="100%"
                      alt={item?.img?.alt}
                    />
                    {item.description.map((des, ind) => (
                      <div
                        key={`${index}${ind}P`}
                        className="modal-content-box-description"
                        dangerouslySetInnerHTML={{ __html: des }}
                      ></div>
                    ))}
                  </div>
                ))}
            </div>
            <div className="modal-content-column">
              {data
                ?.filter((_, index) => index % 2 !== 0) // Filtra solo los índices impares
                .map((item, index) => (
                  <div key={`${index}MM`}>
                    {!item.linkTitle && (
                      <h3
                        className={`modal-content-box-title ${
                          item.title.lenght > 37 ? 'w-100' : ''
                        }`}
                      >
                        {item.title}
                      </h3>
                    )}
                    {item.linkTitle && (
                      <a
                        href={item?.linkTitle}
                        className="link"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        <h3
                          className={`modal-content-box-title  ${
                            item.title.lenght > 37 ? 'w-100' : ''
                          }`}
                        >
                          {' '}
                          {item.title}
                        </h3>
                      </a>
                    )}
                    <img
                      className="modal-content-box-image"
                      src={scenesImages(`${item?.img?.url}`)}
                      width="100%"
                      alt={item?.img?.alt}
                    />
                    {item.description.map((des, ind) => (
                      <div
                        key={`${index}${ind}P`}
                        className="modal-content-box-description"
                        dangerouslySetInnerHTML={{ __html: des }}
                      ></div>
                    ))}
                  </div>
                ))}
            </div>

            {data.map((item, index) => (
              <div key={index} className="modal-content-box">
                {!item.linkTitle && (
                  <h3
                    className={`modal-content-box-title ${
                      item.title.lenght > 37 ? 'w-100' : ''
                    }`}
                  >
                    {item.title}
                  </h3>
                )}
                {item.linkTitle && (
                  <a
                    href={item?.linkTitle}
                    className="link"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    <h3
                      className={`modal-content-box-title  ${
                        item.title.lenght > 37 ? 'w-100' : ''
                      }`}
                    >
                      {' '}
                      {item.title}
                    </h3>
                  </a>
                )}
                <img
                  className="modal-content-box-image"
                  src={scenesImages(`${item?.img?.url}`)}
                  width="100%"
                  alt={item?.img?.alt}
                />
                {item.description.map((des, ind) => (
                  <div
                    key={`${index}${ind}P`}
                    className="modal-content-box-description"
                    dangerouslySetInnerHTML={{ __html: des }}
                  ></div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>,
    document.getElementById('app-modal')
  );
};

export default ModalScene;
